var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "div",
        { staticClass: "mb10 btn-box" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.handleBuild(
                    0,
                    _vm.buildData.contract_renew_switch,
                    "contract_renew_switch"
                  )
                },
              },
            },
            [_vm._v("\n      添加续费\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.handleBuild(
                    0,
                    _vm.buildData.contract_disburse_switch,
                    "contract_disburse_switch"
                  )
                },
              },
            },
            [_vm._v("\n      添加支出\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.handleBuild(
                    0,
                    _vm.buildData.contract_refund_switch,
                    "contract_refund_switch"
                  )
                },
              },
            },
            [_vm._v("\n      添加回款\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "flex" },
        [
          _c("el-col", { staticClass: "amount", attrs: { span: 20 } }, [
            _c("div", { staticClass: "status-span" }, [
              _c("span", { staticClass: "amount-label" }, [
                _vm._v(_vm._s(_vm.$t("customer.paymentstatus")) + "："),
              ]),
              _vm._v(" "),
              parseFloat(_vm.formInfo.data.surplus) === 0
                ? _c("span", { staticClass: "color-success" }, [
                    _vm._v("已结清"),
                  ])
                : _c("span", { staticClass: "color-danger" }, [
                    _vm._v(" 未结清"),
                  ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "amount-label ml36" }, [
                _vm._v("已付金额(元)："),
              ]),
              _c("span", { staticClass: "amount-val" }, [
                _vm._v(_vm._s(_vm.paymentPrice.payment_price)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "amount-label ml36" }, [
                _vm._v("未付金额(元)："),
              ]),
              _c("span", { staticClass: "amount-val" }, [
                _vm._v(_vm._s(_vm.paymentPrice.unpaid_price) + " "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "amount-label ml36" }, [
                _vm._v("累计支出金额(元)："),
              ]),
              _c("span", { staticClass: "amount-val" }, [
                _vm._v(_vm._s(_vm.paymentPrice.expense_price) + " "),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { staticStyle: { width: "100%" }, attrs: { data: _vm.debtData } },
        [
          _c("el-table-column", {
            attrs: { prop: "date", label: "付款时间", "min-width": "180" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "bill_types",
              label: "记录类型",
              "min-width": "110",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.types == 2 ? "warning" : "success",
                        },
                      },
                      [_vm._v(_vm._s(scope.row.types == 2 ? "支出" : "收入"))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "num", label: "付款金额(元)", "min-width": "130" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "pay_type", label: "支付方式", "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.pay_type !== "" ? scope.row.pay_type : "--"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "bill_no", label: "付款单号", "min-width": "120" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "付款审核状态",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 0
                      ? _c(
                          "el-tag",
                          { attrs: { type: "warning", size: "mini" } },
                          [_vm._v(" 待审核")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", size: "mini" } },
                          [_vm._v(" 已通过")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === -1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", size: "mini" } },
                          [_vm._v(" 已撤回")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === 2
                      ? _c(
                          "el-popover",
                          { attrs: { trigger: "hover", placement: "top" } },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("customer.reason")) + ":"),
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(scope.row.fail_msg))]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _c(
                                  "el-tag",
                                  { attrs: { type: "danger", size: "mini" } },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("customer.fail"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "address",
              fixed: "right",
              "min-width": "180",
              label: _vm.$t("public.operation"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleCheck(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    _vm._v(" "),
                    scope.row.status === 0 &&
                    _vm.userInfo.userId == scope.row.card.user_id
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.withdraw(scope.row)
                              },
                            },
                          },
                          [_vm._v("撤回")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === 2
                      ? _c(
                          "el-dropdown",
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "el-dropdown-link el-button--text el-button",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("hr.more")) +
                                    "\n            "
                                ),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right",
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-menu",
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handleDelete(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除 ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status !== 2
                      ? [
                          scope.row.status === 2
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("public.delete")) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block mt10 text-right" },
        [
          _c("el-pagination", {
            attrs: {
              "page-size": _vm.where.limit,
              "current-page": _vm.debtPage,
              layout: "total, prev, pager, next, jumper",
              total: _vm.debtTotal,
            },
            on: { "current-change": _vm.debtChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("applyForPayment", {
        ref: "applyForPayment",
        attrs: { "form-data": _vm.fromData },
      }),
      _vm._v(" "),
      _c("mark-dialog", {
        ref: "markDialog",
        attrs: { config: _vm.configMark },
        on: { isMark: _vm.isOk },
      }),
      _vm._v(" "),
      _vm.isImage
        ? _c("el-image-viewer", {
            attrs: {
              "on-close": _vm.closeImageViewer,
              "url-list": _vm.srcList,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("renew-census", {
        ref: "renewCensus",
        attrs: { config: _vm.configRenewCensus },
      }),
      _vm._v(" "),
      _c("edit-examine", {
        ref: "editExamine",
        attrs: { parameterData: _vm.parameterData, ids: _vm.formInfo.data.id },
        on: {
          isOk: function ($event) {
            return _vm.isOk()
          },
        },
      }),
      _vm._v(" "),
      _c("detail-examine", {
        ref: "detailExamine",
        on: { getList: _vm.getTableData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }